import { Component, OnInit } from '@angular/core';
import {BaseRendererComponent} from "../base-renderer/base-renderer.component";

@Component({
  selector: 'sb-textarea-renderer',
  templateUrl: './textarea-renderer.component.html',
  styleUrls: ['./textarea-renderer.component.scss']
})
export class TextAreaRendererComponent extends BaseRendererComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

}
